export default {
    'en-US': {
        home: {
            modal_situ: {
                h1: 'Report what you saw',
                h4: '(Frontline Health Workers and the General Population)',
                p: 'Attention: You can choose to remain anonymous, but false reports are unacceptable.',
                label1: 'Type of vulnerability you witnessed: ',
                option1: 'Failure to use personal protective equipment (PPE) and/or inappropriate use',
                option2: 'No security conditions and/or guidelines in removing the garment',
                option3: 'Unsuitable installations to avoid contamination',
                option4: 'Professionals without support and/or psychological conditions to work',
                option5: 'Professional was not released from work when presenting compatible symptoms',
                option6: 'Professional was not released from work and is part of the risk group for evolution as a serious case',
                option7: 'Professional was not released from work and is home contact of symptomatic person',
                option8: 'I was a companion of a patient with COVID-19 and did not have access to personal protective equipment (PPE)',
                option9: 'To hear from my relative, I faced queues and crowds at patient care locations',
                option10: 'Other',
                option11: 'Prefer not to say',
                label2: 'Describe: ',
                placeholder1: 'Describe a situation',
                label3: 'Date: ',
                label4: 'Period: ',
                option12: 'Morning',
                option13: 'Afternoon',
                option14: 'Night',
                label5: 'Age: ',
                placeholder2: 'Age',
                label6: 'Income: ',
                option15: '1 minimum salary',
                option16: 'From 3 to 5 minimum salaries',
                option17: 'From 5 to 10 minimum salaries',
                option18: 'From 10 to 20 minimum salaries',
                option19: 'More than 20 minimum salaries',
                option20: 'Prefer not to say',
                label7: 'Education: ',
                option21: 'Not literate',
                option22: 'Literate only',
                option23: 'Incomplete elementary school',
                option24: 'Complete primary education',
                option25: 'Incomplete high school',
                option26: 'Complete high school',
                option27: 'Incomplete University education',
                option28: 'Complete University education',
                option29: 'Graduate',
                option30: 'Master\'s degree',
                option31: 'Doctorate degree',
                option32: 'Do not know',
                option33: 'Prefer not to say',
                label8: 'Professional category: ',
                option34: 'Social Workers',
                option35: 'Biologists',
                option36: 'Biomedical',
                option37: 'Physical Education Professionals',
                option38: 'Nurses',
                option39: 'Pharmacists',
                option40: 'Physiotherapist',
                option41: 'Speech therapists',
                option43: 'Doctors',
                option44: 'Veterinarians',
                option45: 'Nutritionists',
                option46: 'Dentists',
                option47: 'Psychologists',
                option48: 'Occupational Therapists',
                option49: 'Sanitary (Bachelor/Graduation)',
                option50: 'Nursing Technician',
                option51: 'Nursing Assistant',
                option52: 'Community health worker',
                option53: 'Health/endemics surveillance agent',
                option54: 'Receptionist',
                option55: 'Stretcher bearer',
                option56: 'Security',
                option57: 'General Services',
                option58: 'Other',
                option59: 'Prefer not to say',
                label9: 'Gender: ',
                option60: 'Male',
                option61: 'Female',
                option62: 'Undefined',
                label10: 'Race/Color: ',
                option63: 'White',
                option64: 'Black',
                option65: 'Brown',
                option66: 'Indigenous',
                option67: 'Yellow',
                option68: 'Prefer not to say',
                label11: 'Name: ',
                placeholder3: 'Name',
                label12: 'Email: ',
                placeholder4: 'Email',
                label13: 'Issue address:',
                placeholder5: 'Ex: Number, Hollywood St, City',
                p2: 'We will not disclose your personal data',
                button: 'Send',
                button_submit: 'Report sent. If your report does not appear on the map, try again and enter a valid address.'
            },
            modal_vivenciadas: {
                h1: 'Share an experience you had',
                h4: '(Only Frontline Health Workers)',
                p: 'Attention: You can choose to remain anonymous, but false reports are unacceptable.',
                label1: 'Have you ever had a positive diagnosis of the new coronavirus?',
                option1: 'Yes',
                option2: 'No',
                label2: 'Did you develop symptoms compatible with COVID-19?',
                option3: 'Yes',
                option4: 'No',
                label3: 'Did you have direct contact with a symptomatic patient at work?',
                option5: 'Yes',
                option6: 'No',
                label4: 'Type of vulnerability you witnessed:',
                option7: 'Problems accessing PPE',
                option8: 'Lack of training on proper use and withdrawal of clothing',
                option9: 'No security conditions for removing the coat',
                option10: 'Inadequate Installations',
                option11: 'Absence of disinfection of risk areas',
                option12: 'Lack of psychological support',
                option13: 'You have not been released from work when you have symptoms compatible with infection with the new coronavirus',
                option14: 'You have not been released from work and is part of the risk group (age over 70 years; with chronic diseases and/or impaired immune system) for evolution as a severe case',
                option15: 'You have not been released from work and you are home contact of a symptomatic person',
                option16: 'Lack of professional relay policy avoiding overload',
                option17: 'Overcrowding indoors',
                option18: 'Inadequate handling of bodies and respective environments',
                option19: 'Inadequate number of personnel in assistance spaces',
                option20: 'Bullying',
                option21: 'Other',
                option22: 'Prefer not to say',
                label5: 'Describe: ',
                placeholder1: 'Describe a situation',
                label6: 'Date: ',
                label7: 'Period: ',
                option23: 'Morning',
                option24: 'Afternoon',
                option25: 'Night',
                label8: 'Age: ',
                placeholder2: 'Age',
                label9: 'Income: ',
                option26: '1 minimum salary',
                option27: 'From 3 to 5 minimum salaries',
                option28: 'From 5 to 10 minimum salaries',
                option29: 'From 10 to 20 minimum salaries',
                option30: 'More than 20 minimum salaries',
                option31: 'Prefer not to say',
                label10: 'Education: ',
                option32: 'Not literate',
                option33: 'Literate only',
                option34: 'Incomplete elementary school',
                option35: 'Complete elementary school',
                option36: 'Incomplete high school',
                option37: 'Complete high school',
                option38: 'Incomplete University education',
                option39: 'Complete University education',
                option40: 'Graduate',
                option41: 'Master\'s degree',
                option42: 'Doctorate degree',
                option43: 'Do not know',
                option44: 'Prefer not to say',
                label11: 'Professional category: ',
                option45: 'Social Workers',
                option46: 'Biologists',
                option47: 'Biomedical',
                option48: 'Physical Education Professionals',
                option49: 'Nurses',
                option50: 'Pharmacists',
                option51: 'Physiotherapist',
                option52: 'Speech therapists',
                option54: 'Doctors',
                option55: 'Veterinarians',
                option56: 'Nutritionists',
                option57: 'Dentists',
                option58: 'Psychologists',
                option59: 'Occupational Therapists',
                option60: 'Sanitary (Bachelor/Graduation)',
                option61: 'Nursing Technician',
                option62: 'Nursing assistant',
                option63: 'Community health worker',
                option64: 'Health/endemics surveillance agent',
                option65: 'Receptionist',
                option66: 'Stretcher bearer',
                option67: 'Security guard',
                option68: 'General Services',
                option69: 'Other',
                option70: 'Prefer not to say',
                label12: 'Gender: ',
                option71: 'Male',
                option72: 'Famale',
                option73: 'Undefined',
                label13: 'Race/Color: ',
                option74: 'White',
                option75: 'Black',
                option76: 'Brown',
                option77: 'Indigenous',
                option78: 'Yellow',
                option79: 'Prefer not to say',
                label14: 'Name: ',
                placeholder3: 'Name',
                label15: 'Email: ',
                placeholder4: 'Email',
                p2: 'We will not disclose your personal data',
                button: 'Send'
            },
        },

        sobre: {
            h1: 'About',
            p1: 'Every professional who works on the front line in the health sector, in facing the pandemic of COVID-19, should feel safe in the work environment. These environments must adopt protective measures guaranteeing the health of workers and offer conditions for non-overwork, in addition to psychological support given exposure to situations of emotional vulnerability and occupational stress.',
            h3_1: 'Target Audience',
            p2: 'Professionals working at the forefront of the health sector in confronting COVID-19 in public and private networks in Brazil, in addition to the general population.',
            h3_2: 'What is the problem to be solved',
            p3: 'High risk of infection, illness, and deaths of frontline health workers in the context of the COVID-19 pandemic.',
            h3_3: 'Potential health benefits',
            p4: 'Our platform aims to identify potential risks and give visibility to the vulnerability to which professionals in the health sector working on the front line have been exposed. This initiative will allow the survey and mapping of these exposures, allowing the direction of prophylaxis and prevention practices, supporting health authorities and managers in decision-making, aiming at better preparation in the face of exposures by the target audience.'
        },

        infos: {
            h1: 'Important Informations',
            h3_1: 'International guidance for health workers - World Health Organization',
            p1: 'Rights, roles and responsibilities of health workers, including key considerations for occupational safety and health. <a>https://www.who.int/emergencies/diseases/novel-coronavirus-2019/technical-guidance/health-workers</a>',
            h2: 'In Brazil',
            h3_2: 'Ombudsman',
            p2: 'Disque Saúde 136 is one of the channels that the SUS Ombudsman\'s Office offers so that citizens can speak up. We recommend that the same statement be made on this channel. The call is free! <a>https://www.saude.gov.br/saude-de-a-z/ouvidoria-do-sus</a>',
            h3_3: 'Work-related Report',
            p3: 'Citizens can also report the establishment to the Public Ministry of Labor through their own tool <a>https://mpt.mp.br/pgt/servicos/servico-denuncie</a>. When faced with situations of vilification of the labor rights of health professionals, it is incumbent on them to act, since the injury to those affects everyone, not least because the safety of users in these places is mandatory (art. 22 of the CDC). Health surveillance is competent to carry out this inspection. However, in the absence of it, measures such as "Public Civil Action" can be proposed, since it is in the interest of the community that professionals are supported.',
            h3_4: 'Access to Information',
            p4: 'The Access to Information Law (AIL) also guarantees that any citizen can request information from organs and entities of the Federal Executive Branch. Site <a>https://www.gov.br/acessoainformacao/pt-br</a>',
            h3_5: 'Psychological Support',
            p5: 'Demands can be directed to the Ministry of Health (Disque Saúde 136) and the voluntary service of the psychological support network <a>https://www.rededeapoiopsicologico.org.br</a>',
            h3_6: 'Occupational health',
            p6: 'Information regarding health and safety for frontline workers can be found in the Ministry of Health website: <a>https://coronavirus.saude.gov.br/saude-e-seguranca-do-trabalhador-epi</a>',
            p7: 'We reinforce the importance to register in the Strategic Action "BRAZIL COUNT ON ME - HEALTH WORKERS", that aims to train health professionals to face the coronavirus pandemic (COVID-19). This is important to provide safe care and improve self-protection for health workers. Registration in <a>https://registrarh-saude.dataprev.gov.br/</a>',
            h2_2: 'Data for analysis',
            h3_7: 'Data and Maps'
        },

        vulnerabilidade: {
            h1: 'Do you feel vulnerable?',
            p1: 'Do you feel insecure/vulnerable in the work environment? Have you witnessed any situation of vulnerability? Your contribution is very important for you and all professionals working in the health sector. On this website, you can feel safe. There is the possibility to send information anonymously. Your personal data, such as email and IP, will not be revealed.',
            h3_1: 'Right of reply',
            p2: 'Every registration of manifestations will open the possibility of the right of reply by the responsible/manager of the mentioned institution, so that the platform is able to solve the problems presented.',
            h3_2: 'Perspectives',
            p3: 'This initiative provides for the generation/production of content for dissemination in the media and, if necessary, forwarding complaints to the bodies and authorities that can collaborate in the defense of collective interests. Thus, we reinforce the informant\'s responsibility for the situations recorded here.'
        },

        direitos: {
            h1: 'My Rights',
            h3: 'Universal guidelines for health professionals - International Labor Organization',
            p1: 'COVID-19 and the world of work <a> https://www.ilo.org/global/topics/coronavirus/lang--en/index.htm </a>.',
            strong: 'Legal aspects of support to health and related professionals acting on the front line of COVID-19 in public and private healthcare systems in situations of vulnerability. Furthermore, what can society do when suffering or witnessing a situation of vulnerability in these environments? ',
            h2: 'In Brazil',
            p2: 'The Federal Constitution guarantees several rights related to the health integrity of healthcare professionals and in their workplaces. Regulatory rule 32 of the National Health Surveillance Agency (Anvisa) provides for some of these measures, among them: ',
            ol1: {
                li1: 'The supply of Personal Protective Equipment (PPE) in sufficient numbers and its immediate replenishment is guaranteed (32.2.4.7);',
                li2: 'The guarantee of having their materials and work instruments sanitised, including their clothing (32.2.4.6.2 and 32.2.4.8);',
                li3: 'Measures that provide professionals with necessary information about preventive measures for COVID-19;',
                li4: 'Adequate hygiene conditions in toilets, cafeterias and dormitories, which are also capable of containing agglomerations and contamination of surfaces;',
                li5: 'Attention to workers belonging to the risk group, prioritising their efforts through remote means and, in this impossibility, work leave.'
            },
            p3: 'In an adverse situation in which the health professional has contracted the coronavirus or presents symptoms compatible with the virus, measures must be taken:',
            ol2: {
                li1: 'Your immediate removal must be provided, until exams prove otherwise.',
                li2: 'With confirmation, the condition should be characterized as “work-related illness”;',
                li3: 'The worker (the employer or the union) must carry out the immediate Work Accident Report (CAT), which must be registered with the Social Security, in order to obtain a social security benefit and maintain the employment contract for twelve months after the benefit termination (Article 118 of Law 8213/91). ',
                li4: 'The worker must keep all documentation to prove the status with the INSS to recognize the benefit and, in fatal cases, to allow the dependants to receive the benefit;'
            },
        },

        equipe: {
            h1: 'Team',
            ul: {
                li1: {
                    strong: 'Creation, design and development of the initiative:',
                    content: ' David Soeiro Barbosa, Silvia de Almeida Batalha, Paola de Morais Sanchez Palencia, Luziana de Fátima de Oliveira Assuncao, Marcos Vinícius Santos Silva, Géssica Costa de Araújo Souza'
                },
                li2: {
                    strong: 'Contributions to website development:',
                    content: ' Vitor Diniz'
                },
                li3: {
                    strong: 'Legal Advice:',
                    content: ' Samuel Duarte'
                },
                li4: {
                    strong: 'Review and Validation:',
                    content: ' Carlos Leonardo Figueiredo Cunha (nurse), Felipe Ridolfi (infectious disease doctor), Raquel Soeiro (nurse)'
                },
            }
        },

        contato: {
            h1: 'Contact',
            header: 'Contact',
            p1: 'Contact us for more information',
            p2: 'Or send us a message!',
            p3: 'Let\'s stay in contact!',
            p4: 'Email: <a>covidfront@gmail.com</a>',
            label1: 'Name: ',
            placeholder1: 'Enter your name',
            label2: 'Email: ',
            placeholder2: 'Enter your email',
            invalid_email: 'Invalid email',
            label3: 'Message: ',
            placeholder3: 'Enter a message',
            submit: 'Send'
        },
        
        footer: {
            placeholder: 'Search for a city'
        }
    },

    'pt-BR': {
        home: {
            modal_situ: {
                h1: 'Relate o que você viu',
                h4: '(Profissionais da linha de frente e população em geral)',
                p: 'Atenção: Apesar de serem permitidas denúncias anônimas, não são aceitos relatos falsos.',
                label1: 'Tipo de vulnerabilidade presenciada por você: ',
                option1: 'Não utilização de equipamento de proteção individual (EPI) e/ou uso inadequado',
                option2: 'Sem condições de segurança e/ou orientações na retirada de paramentação',
                option3: 'Instalações sem adequação para evitar contaminação',
                option4: 'Profissionais sem apoio e/ou condições psicológicas para trabalhar',
                option5: 'Profissional não teve dispensa do trabalho ao apresentar sintomas compatíveis',
                option6: 'Profissional não teve dispensa do trabalho e faz parte do grupo de risco para evolução como caso grave',
                option7: 'Profissional não teve dispensa do trabalho e é contato domiciliar de pessoa sintomática',
                option8: 'Fui acompanhante de paciente com COVID-19 e não tive acesso a equipamento de proteção individual (EPI)',
                option9: 'Para ter notícias do meu familiar enfrentei filas e aglomerações em locais de atendimento aos pacientes',
                option10: 'Outro',
                option11: 'Prefiro não dizer',
                label2: 'Descreva: ',
                placeholder1: 'Descreva uma situação',
                label3: 'Data: ',
                label4: 'Período: ',
                option12: 'Manhã',
                option13: 'Tarde',
                option14: 'Noite',
                label5: 'Idade: ',
                placeholder2: 'Idade',
                label6: 'Renda: ',
                option15: '1 salário mínimo',
                option16: 'De 3 a 5 salários mínimos',
                option17: 'De 5 a 10 salários mínimos',
                option18: 'De 10 a 20 salários mínimos',
                option19: 'Mais de 20 salários mínimos',
                option20: 'Prefiro não dizer',
                label7: 'Escolaridade: ',
                option21: 'Não alfabetizado',
                option22: 'Somente alfabetizado',
                option23: 'Ensino Fundamental incompleto',
                option24: 'Ensino Fundamental completo',
                option25: 'Ensino Médio incompleto',
                option26: 'Ensino Médio completo',
                option27: 'Ensino Superior incompleto',
                option28: 'Ensino Superior completo',
                option29: 'Superior',
                option30: 'Mestrado',
                option31: 'Doutorado',
                option32: 'Não sabe',
                option33: 'Prefiro não dizer',
                label8: 'Categoria Profissional: ',
                option34: 'Assistentes Sociais',
                option35: 'Biólogos',
                option36: 'Biomédicos',
                option37: 'Profissionais de Educação Física',
                option38: 'Enfermeiros',
                option39: 'Farmacêuticos',
                option40: 'Fisioterapeuta',
                option41: 'Fonoaudiólogos',
                option42: 'Ensino Superior completo',
                option43: 'Médicos',
                option44: 'Médicos Veterinários',
                option45: 'Nutricionistas',
                option46: 'Odontólogos',
                option47: 'Psicólogos',
                option48: 'Terapeutas Ocupacionais',
                option49: 'Sanitarista (Bacharelado/Graduação)',
                option50: 'Técnico de Enfermagem',
                option51: 'Auxiliar de Enfermagem',
                option52: 'Agente comunitário de saúde',
                option53: 'Agente de vigilância em saúde/endemias',
                option54: 'Recepcionista',
                option55: 'Maqueiro',
                option56: 'Segurança',
                option57: 'Serviços gerais',
                option58: 'Outro',
                option59: 'Prefiro não dizer',
                label9: 'Gênero: ',
                option60: 'Masculino',
                option61: 'Feminino',
                option62: 'Indefinido',
                label10: 'Raça/Cor: ',
                option63: 'Branco',
                option64: 'Preto',
                option65: 'Pardo',
                option66: 'Indígena',
                option67: 'Amarelo',
                option68: 'Prefiro não dizer',
                label11: 'Nome: ',
                placeholder3: 'Nome',
                label12: 'Email: ',
                placeholder4: 'Email',
                label13: 'Endereço da ocorrência:',
                placeholder5: 'Ex: Rua Fulano de Tal, Número, Cidade',
                p2: 'Não divulgaremos seus dados pessoais',
                button: 'Enviar',
                button_submit: 'Relato enviado. Caso seu relato não apareça no mapa, tente novamente e informe um endereço válido.'
            },
            modal_vivenciadas: {
                h1: 'Compartilhe uma situação vivenciada por você',
                h4: '(Somente profissionais atuando na linha de frente)',
                p: 'Atenção: Apesar de serem permitidas denúncias anônimas, não são aceitos relatos falsos.',
                label1: 'Já teve diagnóstico positivo ao novo coronavírus? ',
                option1: 'Sim',
                option2: 'Não',
                label2: 'Desenvolveu sintomas compatíveis com COVID-19? ',
                option3: 'Sim',
                option4: 'Não',
                label3: 'Teve contato direto com paciente sintomático no ambiente de trabalho?',
                option5: 'Sim',
                option6: 'Não',
                label4: 'Tipo de vulnerabilidade presenciada por você: ',
                option7: 'Problemas no acesso a EPI',
                option8: 'Falta de treinamento sobre o uso correto e retirada da paramentação',
                option9: 'Sem condições de segurança para retirada da paramentação',
                option10: 'Instalações Inadequadas',
                option11: 'Ausência de desinfecção de áreas de risco',
                option12: 'Falta de apoio psicológico',
                option13: 'Não teve dispensa do trabalho ao apresentar sintomas compatíveis com infecção pelo novo coronavírus',
                option14: 'Não teve dispensa do trabalho e faz parte do grupo de risco (idade acima de 70 anos; com doenças crônicas e/ou comprometimento do sistema imunológico) para evolução como caso grave',
                option15: 'Não teve dispensa do trabalho e é contato domiciliar de pessoa sintomática',
                option16: 'Falta de política de revezamento de profissionais evitando sobrecarga',
                option17: 'Superlotação de ambientes fechados',
                option18: 'Manejo inadequado dos corpos e respectivos ambientes',
                option19: 'Número inadequado de pessoal em espaços assistenciais',
                option20: 'Assédio moral',
                option21: 'Outro',
                option22: 'Prefiro não dizer',
                label5: 'Descreva: ',
                placeholder1: 'Descreva uma situação',
                label6: 'Data: ',
                label7: 'Período: ',
                option23: 'Manhã',
                option24: 'Tarde',
                option25: 'Noite',
                label8: 'Idade: ',
                placeholder2: 'Idade',
                label9: 'Renda: ',
                option26: '1 salário mínimo',
                option27: 'De 3 a 5 salários mínimos',
                option28: 'De 5 a 10 salários mínimos',
                option29: 'De 10 a 20 salários mínimos',
                option30: 'Mais de 20 salários mínimos',
                option31: 'Prefiro não dizer',
                label10: 'Escolaridade: ',
                option32: 'Não alfabetizado',
                option33: 'Somente alfabetizado',
                option34: 'Ensino Fundamental incompleto',
                option35: 'Ensino Fundamental completo',
                option36: 'Ensino Médio incompleto',
                option37: 'Ensino Médio completo',
                option38: 'Ensino Superior incompleto',
                option39: 'Ensino Superior completo',
                option40: 'Superior',
                option41: 'Mestrado',
                option42: 'Doutorado',
                option43: 'Não sabe',
                option44: 'Prefiro não dizer',
                label11: 'Categoria Profissional: ',
                option45: 'Assistentes Sociais',
                option46: 'Biólogos',
                option47: 'Biomédicos',
                option48: 'Profissionais de Educação Física',
                option49: 'Enfermeiros',
                option50: 'Farmacêuticos',
                option51: 'Fisioterapeuta',
                option52: 'Fonoaudiólogos',
                option53: 'Ensino Superior completo',
                option54: 'Médicos',
                option55: 'Médicos Veterinários',
                option56: 'Nutricionistas',
                option57: 'Odontólogos',
                option58: 'Psicólogos',
                option59: 'Terapeutas Ocupacionais',
                option60: 'Sanitarista (Bacharelado/Graduação)',
                option61: 'Técnico de Enfermagem',
                option62: 'Auxiliar de Enfermagem',
                option63: 'Agente comunitário de saúde',
                option64: 'Agente de vigilância em saúde/endemias',
                option65: 'Recepcionista',
                option66: 'Maqueiro',
                option67: 'Segurança',
                option68: 'Serviços gerais',
                option69: 'Outro',
                option70: 'Prefiro não dizer',
                label12: 'Gênero: ',
                option71: 'Masculino',
                option72: 'Feminino',
                option73: 'Indefinido',
                label13: 'Raça/Cor: ',
                option74: 'Branco',
                option75: 'Preto',
                option76: 'Pardo',
                option77: 'Indígena',
                option78: 'Amarelo',
                option79: 'Prefiro não dizer',
                label14: 'Nome: ',
                placeholder3: 'Nome',
                label15: 'Email: ',
                placeholder4: 'Email',
                p2: 'Não divulgaremos seus dados pessoais',
                button: 'Enviar'
            },
        },

        sobre: {
            h1: 'Sobre',
            p1: 'Todo profissional que atua na linha de frente no setor saúde, no enfrentamento da pandemia da COVID-19, deve se sentir seguro no ambiente de trabalho. Estes ambientes devem adotar medidas de proteção garantindo a saúde dos trabalhadores e oferecer condições para a não sobrecarga de trabalho, além de suporte psicológico dada a exposição a situações de vulnerabilidade emocional e estresse ocupacional.',
            h3_1: 'Público-alvo',
            p2: 'Profissionais atuando na linha de frente do setor saúde no enfrentamento da COVID-19 nas redes pública e privada no Brasil, além disso a população em geral.',
            h3_2: 'Qual o problema a ser resolvido',
            p3: 'Elevado acometimento de profissionais do setor saúde no contexto da pandemia da COVID-19 causada pelo novo coronavírus SARS-CoV-2.',
            h3_3: 'Potenciais benefícios para saúde',
            p4: 'Nossa plataforma visa identificar potenciais riscos e dar visibilidade à vulnerabilidade a que têm sido expostos profissionais do setor saúde atuando na linha de frente. Esta iniciativa permitirá o levantamento e mapeamento destas exposições, permitindo o direcionamento de práticas de profilaxia e de prevenção apoiando as autoridades e gestores de saúde na tomada de decisão visando melhor preparo diante de exposições do público alvo.'
        },
        
        infos: {
            h1: 'Informações Importantes',
            h3_1: 'Orientações universais para profissionais da saúde - Organização Mundial da Saúde',
            p1: 'Direitos, papéis e responsabilidades dos trabalhadores da saúde, incluindo considerações importantes sobre segurança e saúde no trabalho. <a>https://www.who.int/emergencies/diseases/novel-coronavirus-2019/technical-guidance/health-workers</a>',
            h2: 'No Brasil',
            h3_2: 'Ouvidoria',
            p2: 'O Disque Saúde 136 é um dos canais que a Ouvidoria-Geral do SUS oferece para que o cidadão possa se manifestar. Recomendamos que a mesma manifestação seja feita neste canal. A ligação é gratuita! <a>https://www.saude.gov.br/saude-de-a-z/ouvidoria-do-sus</a>',
            h3_3: 'Denúncia relacionada ao trabalho',
            p3: 'Os cidadãos podem ainda denunciar o estabelecimento ao Ministério Público do Trabalho por meio de ferramenta própria <a>https://mpt.mp.br/pgt/servicos/servico-denuncie</a>. A sociedade ao se deparar com situações de vilipêndio de direitos trabalhistas dos profissionais de saúde tem a incumbência de agir, posto que a lesão àqueles afeta a todos, até porque a segurança dos usuários nesses locais é obrigatória (art. 22 do CDC). A vigilância sanitária é competente para realizar essa fiscalização. No entanto, na falta dela, medidas como a “Ação Civil Pública” podem ser propostas, posto que é interesse da coletividade que os profissionais estejam amparados.',
            h3_4: 'Acesso à informação',
            p4: 'A Lei de Acesso à Informação (LAI) garante ainda que qualquer cidadão pode solicitar informações a órgãos e entidades do Poder Executivo Federal. Site <a>https://www.gov.br/acessoainformacao/pt-br</a>',
            h3_5: 'Apoio psicológico',
            p5: 'Demandas podem ser direcionadas ao Ministério da Saúde (Disque Saúde 136) e o serviço voluntário da Rede de apoio psicológico <a>https://www.rededeapoiopsicologico.org.br</a>',
            h3_6: 'Saúde ocupacional',
            p6: 'Informações sobre a saúde e segurança do trabalhador podem ser obtidas no site do Ministério da Saúde <a>https://coronavirus.saude.gov.br/saude-e-seguranca-do-trabalhador-epi</a>',
            p7: 'Ressaltamos o cadastramento na Ação Estratégica "O BRASIL CONTA COMIGO – PROFISSIONAIS DA SAÚDE", voltada à capacitação de profissionais da área de saúde para o enfrentamento à pandemia do Coronavírus (COVID-19). O treinamento é importante para o atendimento seguro e para maior autoproteção dos profissionais de saúde. Cadastro no link: <a>https://registrarh-saude.dataprev.gov.br/</a>',
            h2_2: 'Dados para Análises',
            h3_7: 'Dados e Mapas'
        },

        vulnerabilidade: {
            h1: 'Se sente vulnerável?',
            p1: 'Se sente inseguro/vulnerável no ambiente de trabalho? Testemunhou alguma situação de vulnerabilidade? Sua contribuição é muito importante para você e todos os profissionais atuando no setor saúde. Neste site, você pode se sentir seguro. Há a possibilidade de enviar informações anonimamente. Seus dados pessoais, como e-mail e IP, não serão revelados.',
            h3_1: 'Direito de resposta',
            p2: 'Todo registro de manifestação abrirá a possibilidade do direito de resposta pelo responsável/gestor da instituição citada, de forma que a plataforma seja resolutiva dos problemas apresentados.',
            h3_2: 'Perspectivas',
            p3: 'Esta iniciativa prevê a geração/produção de conteúdo para divulgação na mídia e, caso necessário, encaminhamento das reclamações aos órgãos e autoridades que possam colaborar na defesa dos interesses coletivos. Assim, reforçamos a responsabilidade do informante pelas situações aqui registradas.'
        },

        direitos: {
            h1: 'Meus Direitos',
            h3: 'Orientações universais para profissionais da saúde - Organização Internacional do Trabalho',
            p1: 'COVID-19 e o mundo do trabalho <a>https://www.ilo.org/global/topics/coronavirus/lang--en/index.htm</a>.',
            strong: 'Aspectos jurídicos de apoio a profissionais de saúde e afins atuando na linha de frente do COVID-19 no cuidado em saúde nas redes pública e privada em situação de vulnerabilidade. Além disso, o que a sociedade pode fazer ao sofrer ou testemunhar alguma situação de vulnerabilidade nestes ambientes?',
            h2: 'No Brasil',
            p2: 'A Constituição Federal garante diversos direitos relacionais à saúde dos profissionais da saúde e em seus locais de trabalho. A norma regulamentadora 32 da Agência Nacional de Vigilância Sanitária (Anvisa) dispõe sobre algumas dessas medidas, dentre elas:',
            ol1: {
                li1: 'O fornecimento de Equipamentos de Proteção Individual (EPI) em número suficiente e seja garantido o seu imediato reabastecimento (32.2.4.7);',
                li2: 'A garantia de terem seus materiais e instrumentos de trabalho higienizados, inclusive as suas vestimentas (32.2.4.6.2 e 32.2.4.8);',
                li3: 'Medidas que forneçam informações necessárias aos profissionais acerca das medidas de prevenções ao Covid-19;',
                li4: 'Condições adequadas de higiene nos sanitários, nos refeitórios e nos dormitórios, as quais também sejam capazes de conter aglomerações e a contaminação de superfícies;',
                li5: 'Atenção aos trabalhadores pertencentes ao grupo de risco, priorizando o seu ofício por meio de teletrabalho e, nesta impossibilidade, o afastamento ao trabalho.'
            },
            p3: 'Em um quadro adverso em que o profissional da saúde contraiu o coronavírus ou apresente sintomas compatíveis com o vírus, medidas devem ser tomadas:',
            ol2: {
                li1: 'O seu imediato afastamento deve ser providenciado, até que exames provem o contrário.',
                li2: 'Com a confirmação, o quadro deve ser caracterizado como “doença relacionada ao trabalho”;',
                li3: 'O trabalhador (o empregador ou o sindicato) deve realizar a imediata Comunicação de Acidente de Trabalho (CAT), a qual deverá ser registrada junto à Previdência Social, para a obtenção de benefício previdenciário e a manutenção do contrato de trabalho do empregado por doze meses após a cessação do seu benefício (art. 118 da Lei 8213/91).',
                li4: 'O trabalhador deve guardar toda a documentação para comprovação do quadro junto ao INSS para reconhecimento do benefício e, em casos fatais, o recebimento de pensão por morte dos seus dependentes;'
            },
        },

        equipe: {
            h1: 'Equipe',
            ul: {
                li1: {
                    strong: 'Criação, design e desenvolvimento da iniciativa:',
                    content: ' David Soeiro Barbosa, Silvia de Almeida Batalha, Paola de Morais Sanchez Palencia, Luziana de Fátima de Oliveira Assuncao, Marcos Vinícius Santos Silva, Géssica Costa de Araújo Souza'
                },
                li2: {
                    strong: 'Contribuições no desenvolvimento:',
                    content: ' Vitor Diniz'
                },
                li3: {
                    strong: 'Assessoria Jurídica:',
                    content: ' Samuel Duarte'
                },
                li4: {
                    strong: 'Revisão e validação:',
                    content: ' Carlos Leonardo Figueiredo Cunha (enfermeiro), Felipe Ridolfi (médico infectologista), Raquel Soeiro (enfermeira)'
                },
            }
        },

        contato: {
            h1: 'Entre em contato',
            header: 'Contato',
            p1: 'Entre em contato conosco para maiores informações.',
            p2: 'Ou nos mande uma mensagem!',
            p3: 'Vamos ficar em contato!',
            p4: 'Email: <a>covidfront@gmail.com</a>',
            label1: 'Nome: ',
            placeholder1: 'Digite o seu nome',
            label2: 'Email: ',
            placeholder2: 'Digite o seu email',
            invalid_email: 'Email inválido',
            label3: 'Mensagem: ',
            placeholder3: 'Digite uma mensagem',
            submit: 'Enviar'
        },
        
        footer: {
            placeholder: 'Pesquisar por uma cidade'
        }
    }
}
